<template>
    <main class="basket">
        <section class="cart-alert" v-show="isSelectedDeliveryOverTime" ref="overTimeSection">
            <div class="container-fluid">
                <div class="collision item-summary">
                    <h6>{{ _('Položky, ktoré nemožno doručiť v aktuálnom čase:') }}</h6>
                    <table>
                        <thead>
                            <tr>
                                <th class="hidden-xs hidden-sm">Názov produktu</th>
                                <th class="hidden-md hidden-lg">Produkt</th>

                                <th class="hidden-xs hidden-sm">Otváracie hodiny</th>

                                <th class="min-col">DPH %</th>

                                <th class="hidden-xs hidden-sm min-col">Cena za ks</th>
                                <th class="hidden-md hidden-lg">Cena/ks</th>

                                <th class="hidden-xs hidden-sm min-col">Cena spolu</th>
                                <th class="hidden-md hidden-lg">Spolu</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, id) in basket" v-if="!isOpened(item)">
                                <td><a v-bind:href="getProductAction(item.product)" target="_blank">{{ item.product.name }}</a>
                                    <span v-for="(variant, $variantIndex) in getVariants(item.variants)">{{ variant.name }}<span class="variantGap" v-if="$variantIndex + 1 < getVariants(item.variants).length">,</span></span>
                                </td>
                                <td class="hidden-xs hidden-sm timetable-td">
                                    <div class="dropdown">
                                        <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                            {{ _('Zobraziť otváracie hodiny') }}
                                            <i class="fa fa-angle-down"></i>
                                        </button>
                                        <ul class="dropdown-menu times-menu" aria-labelledby="dropdownMenu1">
                                            <li v-for="(times, day) in getItemOpeningHours(item)">
                                                <ul class="list-inline clearfix list-inline-inner times">
                                                    <li>{{ day }} <span v-if="times[1]">- {{ times[1] }}</span> <span class="dott">:</span></li>
                                                    <li>{{ times[0][0] }} - {{ times[0][1] }}</li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                                <td><div class="item-price">{{ item.product.vat }}%</div></td>
                                <td><div class="item-price">{{ toPrice(itemPrice(item)) }} €</div></td>
                                <td><div class="item-price">{{ toPrice(itemPrice(item) * item.quantity) }} €</div></td>
                                <td class="detail-select">

                                    <div class="amount" v-bind:class="{ 'error' : item.product.quantity < item.quantity }">
                                        {{ item.quantity }}
                                        <span>ks</span>
                                    </div>
                                </td>
                                <td><a @click.prevent="removeItem(id)"><i class="fa fa-times" aria-hidden="true"></i></a></td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="alert alert-warning" v-if="hasCustomProductTimesWithMultipleTimeCategories">
                        {{ _('V objednávke sa nachádzajú tovary s odlištnými otváracími hodinami. Naplánované doručenie bude limitované pre možnosť vytvorenia objednávky.') }}
                    </div>
                </div>

                <div class="continue-button">
                    <div class="animated pulse infinite">
                        <a href="#">
                            <i class="material-icons">keyboard_arrow_down</i>
                            {{ _('Pokračovať naplánovaním doručenia') }}
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <section class="product-detail">
            <div class="container-fluid cart-delivery">
                <div class="delivery" v-if="count">
                    <div class="delivery-title"><h4>{{ _('Doručenie') }}</h4></div>
                    <div class="row boxes">
                        <div class="col-sm-6 col" v-if="!isContractor">
                            <div v-bind:class="{ 'disabled' : hasUnopenedProducts(getDelivery(1), true), 'active' : isSelectedDelivery(1) }" @click="setDelivery(1, true)" class="col-inner clearfix">
                                <div class="pull-left icon normal">
                                    <img v-bind:src="asset('images/truck'+(isSelectedDelivery(1) ? '-hover' : '')+'.svg')">
                                </div>
                                <div class="pull-left">
                                    <h6>{{ getDeliveryName(getDelivery(1)) }}</h6>
                                    <span class="blue"> {{ getDeliveryPrice(getDelivery(1)) }}€ </span><small v-if="getDelivery(1).note">({{ getDelivery(1).note }})</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col" v-if="!isContractor">
                            <div v-bind:class="{ 'disabled' : hasUnopenedProducts(getDelivery(2), true), 'active' : isSelectedDelivery(2) }" @click="setDelivery(2, true)" class="col-inner clearfix">
                                <div class="pull-left icon express">
                                    <img v-bind:src="asset('images/truck-time'+(isSelectedDelivery(2) ? '-hover' : '')+'.svg')">
                                </div>
                                <div class="pull-left">
                                    <h6>{{ getDeliveryName(getDelivery(2)) }}</h6>
                                    <span class="blue"> {{ getDeliveryPrice(getDelivery(2)) }}€ </span><small v-if="getDelivery(2).note">({{ getDelivery(2).note }})</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col">
                            <div v-bind:class="{ 'disabled' : hasUnopenedProducts(getDelivery(3), true), 'active' : isSelectedDelivery(3) }" @click="setDelivery(3, true)" class="col-inner clearfix">
                                <div class="pull-left icon pickup">
                                    <img v-bind:src="asset('images/path'+(isSelectedDelivery(3) ? '-hover' : '')+'.svg')">
                                </div>
                                <div class="pull-left">
                                    <h6>{{ getDeliveryName(getDelivery(3)) }}</h6>
                                    <span class="blue"> {{ getDeliveryPrice(getDelivery(3)) }}€ </span><small v-if="getDelivery(3).note">({{ getDelivery(3).note }})</small>
                                </div>
                            </div>
                        </div>
                        <div class="col col-sm-6" v-if="isContractor">
                            <div v-bind:class="{ 'active' : isSelectedDelivery(5) }" @click="setDelivery(5)" class="col-inner clearfix">
                                <div class="pull-left icon pickup">
                                    <img v-bind:src="asset('images/path'+(isSelectedDelivery(5) ? '-hover' : '')+'.svg')">
                                </div>
                                <div class="pull-left">
                                    <h6>{{ getDeliveryName(getDelivery(5)) }}</h6>
                                    <span class="blue"> {{ getDeliveryPrice(getDelivery(5)) }}€ </span><small v-if="getDelivery(5).note">({{ getDelivery(5).note }})</small>
                                </div>
                            </div>
                        </div>
                        <div class="col col-sm-6" v-if="!isContractor">
                            <div v-bind:class="{ 'active' : isSelectedDelivery(4) }" @click="setDelivery(4)" class="col-inner clearfix">
                                <div class="pull-left icon pickup">
                                    <img v-bind:src="asset('images/path'+(isSelectedDelivery(4) ? '-hover' : '')+'.svg')">
                                </div>
                                <div class="pull-left">
                                    <h6>{{ getDeliveryName(getDelivery(4)) }}</h6>
                                    <span class="blue"> {{ getDeliveryPrice(getDelivery(4)) }}€ </span><small v-if="getDelivery(4).note">({{ getDelivery(4).note }})</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item-summary" id="plannedDelivery">
                    <div v-if="(isSelectedDelivery(4) || ownContractorDelivery || isSelectedDelivery(5) && isContractor) && count > 0">
                        <div class="item-title no-top">
                            <h4 v-if="ownContractorDelivery">{{ _('Vyberte dátum a čas osobného odberu') }}</h4>
                            <h4 v-else>{{ _('Vyberte dátum a čas naplánovaného doručenia') }}</h4>
                        </div>

                        <div class="days clearfix">
                            <div class="day" v-for="i in availableDays" v-if="hasAvailableDays(i)">
                                <h2 @click="selectDay(i)">{{ getDayName(i) }} <span>{{ getDate(i) }}</span></h2>

                                <div class="time" :class="{ active : selected_day == i }">
                                    <div v-for="(days, week_day) in getScheduleHour(i)" v-if="hasOneTime(days, i, week_day)">
                                        <button type="button" v-for="time in days" v-if="!isInPast(i, week_day, time)" data-toggle="tooltip" :class="{ active : isSelectedTime(i, time) }" @click.prevent="setDeliveryTime(i, week_day, time)">{{ getTimeInterval(time) }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="alert alert-warning" v-if="hasNoAvailableHours">{{ _('Naplnánované doručenie nie je možné pre kombináciu Vášho tovaru v košíku.') }}</div>
                    </div>

                    <div class="alert alert-danger empty no-products" v-if="!count">
                        <strong>Upozornenie:</strong> {{ _('Váš nákupný košík je prázdny.') }}
                    </div>

                    <div class="item-title"><h4>{{ _('Zhrnutie objednávky') }}</h4></div>
                    <table>
                        <thead>
                            <tr>
                                <th class="hidden-xs hidden-sm">{{ _('Názov produktu') }}</th>
                                <th class="hidden-md hidden-lg">Produkt</th>

                                <th>DPH %</th>

                                <th class="hidden-xs hidden-sm min-col">Cena za ks</th>
                                <th class="hidden-md hidden-lg min-col">Cena/ks</th>

                                <th>Počet ks</th>

                                <th class="hidden-xs hidden-sm">Cena spolu</th>
                                <th class="hidden-md hidden-lg">Spolu</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, id) in basket" v-if="isOpened(item)">
                                <td>
                                    <a v-bind:href="getProductAction(item.product)" target="_blank">{{ item.product.name }}</a>
                                    <span v-if="item.product.variant">{{ item.product.variant }}</span>
                                    <span v-for="(variant, $variantIndex) in getVariants(item.variants)">{{ variant.name }}<span class="variantGap" v-if="$variantIndex + 1 < getVariants(item.variants).length">,</span></span>
                                </td>
                                <td><div class="item-price">{{ item.product.vat }}%</div></td>
                                <td><div class="item-price">{{ toPrice(itemPrice(item)) }} €</div></td>
                                <td class="detail-select quantity">
                                    <div class="amount" v-bind:class="{ 'error' : hasProductNotEnoughtQty(item.product) }">
                                        {{ item.quantity }}
                                        <span>ks</span>
                                    </div>
                                </td>
                                <td><div class="item-price">{{ toPrice(itemPrice(item) * item.quantity) }} €</div></td>
                            </tr>
                            <tr v-for="(product) in freeProducts">
                                <td><a v-bind:href="getProductAction(product)" target="_blank">{{ product.name }}</a> <span v-if="product.variant">{{ product.variant }}</span></td>
                                <td><div class="item-price">{{ product.vat }}%</div></td>
                                <td><div class="item-price free">{{ freeProductPrice }} €</div></td>
                                <td class="detail-select quantity"><div class="amount">1 ks</div></td>
                                <td><div class="item-price free">{{ freeProductPrice }} €</div></td>
                            </tr>
                            <tr v-if="getSelectedDelivery">
                                <td>{{ getDeliveryName(getSelectedDelivery) }}</td>
                                <td><div class="item-price">23%</div></td>
                                <td><div class="item-price">{{ getDeliveryPrice(getSelectedDelivery) }} €</div></td>
                                <td class="detail-select quantity"><div class="amount">1 ks</div></td>
                                <td><div class="item-price">{{ getDeliveryPrice(getSelectedDelivery) }} €</div></td>
                                <td></td>
                            </tr>
                            <tr v-for="product in getAdditional">
                                <td><a v-bind:href="getProductAction(product)" target="_blank">{{ product.name }}</a> <span v-if="product.variant">{{ product.variant }}</span></td>
                                <td><div class="item-price">{{ product.vat }}%</div></td>
                                <td><div class="item-price free">{{ toPrice(product.price) }} €</div></td>
                                <td class="detail-select quantity"><div class="amount">{{ product.quantity }} ks</div></td>
                                <td><div class="item-price free">{{ toPrice(product.price * product.quantity) }} €</div></td>
                            </tr>
                            <tr v-if="cupoun">
                                <td class="coupon-td">{{ _('Zľavový kód') }}
                                    <div>
                                        <span v-if="cupoun.free_delivery">{{ _('Doprava zdarma') }}</span>
                                        <span v-else-if="cupoun.discount_percent"><strong>{{ cupoun.discount_percent }} %</strong></span>
                                        <span v-else-if="cupoun.discount_price"><strong>{{ cupoun.discount_price }} €</strong></span>
                                        <span v-if="cupoun.product && hasCouponProductInBasket">, pre produkt <strong>{{ cupoun.product.name }}</strong></span>
                                        <span v-if="cupoun.price_limit > 0">, v minimálnej cene objednávky <strong>{{ cupoun.price_limit }} €</strong></span>
                                    </div>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td><div class="item-price blue">
                                    <span v-if="couponPrice > 0">-{{ couponPrice }} €</span>
                                </div></td>
                                <td></td>
                            </tr>
                            <tr v-if="discountPrice > 0">
                                <td class="coupon-td">{{ _('Zľava') }}
                                    <div>
                                        <span v-if="isContractor && getSelectedDelivery.contractor_discount > 0">{{ parseFloat(getSelectedDelivery.contractor_discount).toFixed(1) + '% ' + _('pre osobný odber') }}</span>
                                    </div>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td><div class="item-price blue">
                                    <span v-if="discountPrice > 0">-{{ discountPrice }} €</span>
                                </div></td>
                                <td></td>
                            </tr>
                            <tr class="summary-col">
                                <td>{{ _('Zhrnutie') }}</td>
                                <td colspan="4">
                                    <div class="item-price">{{ totalPriceWithDeliveryWithoutTax }} € bez DPH</div>
                                    <div class="item-price blue">{{ totalPriceWithDelivery }} € s DPH</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <form @submit.prevent class="paymentOr">
                <div class="container">
                    <div class="clearfix payment-buttons">
                        <div class="text-right pull-left cart-payment-content cart-checkboxes">
                            <div class="checkbox-inline">
                                <input type="checkbox" name="accept_vop" value="1" v-model="vop" class="checked" id="accept">
                                <label for="accept">
                                    Súhlasim s<span class="hidden-sm hidden-xs">o</span> <a target="_blank" :href="vopurl"><b class="hidden-xs hidden-sm">Všeobecnými obchodnými podmienkami</b><b class="hidden-lg hiddem-md">VOP</b></a>
                                </label>
                            </div>
                            <div class="checkbox-inline">
                                <input type="checkbox" name="has18" value="1" v-model="has18" class="checked" id="has18">
                                <label for="has18">
                                    {{ _('Máte viac ako 18 rokov?') }}
                                </label>
                            </div>
                        </div>
                        <div class="text-right pull-right">
                            <a :href="prevstep"><button type="button" class="btn view-btn">Predchadzajúci krok</button></a>

                            <button type="submit" class="btn blue-btn add-btn" :class="{ hidden : loading }" @click="submitOrder">{{ _('Odoslať objednávku s povinnosťou platby') }}</button>
                            <button type="button" class="btn blue-btn add-btn loading" :class="{ hidden : !loading }"><i class="updating fa fa-refresh"></i> {{ _('Odosiela sa') }}...</button>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </main>
</template>

<script type="text/javascript">
    import Core from './core.js';

    export default {
        props : ['basket', 'bag', 'region', 'vopurl', 'prevstep', 'deadlines', 'discount_code'],

        data(){
            var delivery_items = window.Laravel.data.delivery,
                default_delivery = this.getDefaultDeliveryTime(delivery_items, true);

            return {
                vop : false,
                has18 : this.$root.client.has18||false,

                delivery : {
                    region : this.region ? JSON.parse(this.region) : null,
                    items : delivery_items,
                    selected : default_delivery.selected,
                    time : default_delivery.time.toString(),
                    deadlines : JSON.parse(this.deadlines||'[]'),
                },
                selected_day : null,

                limit : window.Laravel.data.limit,
                opening_hours : this.$root.opening_hours,
                loading : false,

                code : this.discount_code,
                cupoun : null,
                code_status : null,
                availableDays : [1, 2, 3, 4, 5, 6, 7, 8, 9],
                freeProductPrice : window.Laravel.data.free_product_price,
            };
        },

        mounted(){
            this.checkCode(this.code, true);

            this.checkForUnCorrectUserDelivery();

            this.autoSelectDay();
        },

        watch : {
            //Save delivery into session after change
            delivery : {
                deep : true,
                handler(change){
                    //If is planned delivery, then save selected date into server
                    var timestamp = this.isPlannedDelivery ? (new Date(change.time).getTime() / 1000) : null;

                    //Auto select day
                    if ( timestamp )
                        this.autoSelectDay(change.time);

                    if ( this.getSelectedDelivery )
                        $.get(window.Laravel.requests.basket.updateDelivery, { delivery : this.getSelectedDelivery.id, timestamp : timestamp });
                },
            },
            isSelectedDeliveryOverTime(state, oldstate){
                if ( state == true && oldstate == false ){
                    $('html, body').animate({
                        scrollTop: $(this.$refs.overTimeSection).offset().top - 100,
                    }, 500);
                }
            }
        },

        computed: {
            count : Core.computed.count,
            baseTotalPrice : Core.computed.baseTotalPrice,
            totalPrice : Core.computed.totalPrice,
            totalPriceWithoutTax : Core.computed.totalPriceWithoutTax,
            totalPriceWithoutTaxAndDiscount : Core.computed.totalPriceWithoutTaxAndDiscount,
            totalPriceWithoutAdditional : Core.computed.totalPriceWithoutAdditional,
            totalPriceWithDiscount : Core.computed.totalPriceWithDiscount,
            totalPriceProfitableWithDiscount : Core.computed.totalPriceProfitableWithDiscount,
            totalPriceProfitable: Core.computed.totalPriceProfitable,
            getAdditionalPrice: Core.computed.getAdditionalPrice,
            getAdditionalPriceWithoutTax: Core.computed.getAdditionalPriceWithoutTax,
            hasCouponProductInBasket : Core.computed.hasCouponProductInBasket,
            couponPrice : Core.computed.couponPrice,
            discountPrice : Core.computed.discountPrice,
            freeProducts : Core.computed.freeProducts,
            getAdditional : Core.computed.getAdditional,
            isContractor : Core.computed.isContractor,
            ownContractorDelivery(){
                return this.isContractor && this.isSelectedDelivery(3);
            },
            totalPriceWithDelivery(){
                var total = parseFloat(this.totalPriceWithDiscount);

                if ( this.getSelectedDelivery )
                    total += parseFloat(this.getDeliveryPrice( this.getSelectedDelivery ));

                return this.toPrice(total);
            },
            totalPriceWithDeliveryWithoutTax(){
                var total = parseFloat(this.totalPriceWithoutTaxAndDiscount);

                if ( this.getSelectedDelivery )
                    total += parseFloat(this.getDeliveryPrice(this.getSelectedDelivery)) / (1 + (window.Laravel.data.vat / 100));

                return this.toPrice(total);
            },
            getSelectedDelivery(){
                if ( ! this.delivery.selected )
                    return null;

                return _.find(this.delivery.items, { id : parseInt(this.delivery.selected) })
            },
            isSelectedDeliveryOverTime(){
                //Get delivery delay
                var delay = this.getSelectedDelivery ? (this.getSelectedDelivery.delay_before + this.getRegionAttribute(this.getSelectedDelivery, 'delay')) : 0,
                    date = moment(new Date(this.delivery.time)).add(delay, 'minutes');

                for ( var key in this.basket )
                {
                    if ( ! this.isOpened(this.basket[key], null, date) )
                        return true;
                }

                return false;
            },
            hasNonExpressProducts(){
                //Check if basket has product with non express delivery
                for ( var key in this.basket ) {
                    if ( _.find(this.basket[key].product.subcategories, { nonexpress : true }) ) {
                        return true;
                    }
                }

                return false;
            },
            hasNonStoreDeliveryProducts(){
                //Check if basket has product with non express delivery
                for ( var key in this.basket ) {
                    if ( _.find(this.basket[key].product.subcategories, { disable_store_delivery : true }) ) {
                        return true;
                    }
                }

                return false;
            },
            //Get all selected opening hours
            selectedTimesCategories(){
                let categories = [];

                for ( var key in this.basket ){
                    let product = this.basket[key].product;

                    //If product does not have custom opening times
                    if ( !(product.available_from_time && product.available_to_time || (product.times && product.times.length)) ){
                        categories.push(this.getCategory(this.basket[key]).opening_hours_id);
                    }
                }

                return _.uniq(categories);
            },
            hasCustomProductTimesWithMultipleTimeCategories(){
                var has = false;

                for ( var key in this.basket ) {
                    let product = this.basket[key].product;

                    if ( product && (product.available_from_time && product.available_to_time || (product.times && product.times.length)) ) {
                        has = true;
                    }
                }

                return this.selectedTimesCategories.length > 0 && has;
            },
            getClientOpeningHours(){
                var times = _.find(this.$root.opening_hours, { id : this.isContractor ? 3 : 1 });

                //We we want goods from only one category, we can open this day
                for ( var k in times.times ) {
                    if ( times.times[k].opened == false && this.selectedTimesCategories.indexOf(1) == -1 ) {
                        times.times[k].opened = true;
                    }
                }

                for ( var key in this.basket ) {
                    let product = this.basket[key].product,

                        //If this is first product in basket, we can oweride default timetable schedule. But no one product
                        //cannot be available from default timetable
                        isFirstWithoutOtherTimeCategories = (key == 0 && this.selectedTimesCategories.indexOf(1) == -1 );

                    //Mutate global timetable by global product times
                    if ( product && product.available_from_time && product.available_to_time ) {
                        let from = product.available_from_time.split(' ')[1].substr(0, 5),
                            to = product.available_to_time.split(' ')[1].substr(0, 5);

                        for ( var k in times.times ) {
                            let dayTime = _.find(product.times, { day : times.times[k].day });

                            //If product has specific day time schedule
                            if ( dayTime ){
                                continue;
                            }

                            if ( times.times[k].to > to || times.times[k].from > times.times[k].to || isFirstWithoutOtherTimeCategories ){
                                times.times[k].to = to;
                            }

                            if ( from > times.times[k].from || isFirstWithoutOtherTimeCategories ){
                                times.times[k].from = from;
                            }
                        }
                    }

                    //Mutate global timetable opening times by given product custom days
                    if ( product.times ){
                        for ( var k in product.times ) {
                            let dayTime = _.find(times.times, { day : product.times[k].day }),
                                from = product.times[k].from,
                                to = product.times[k].to;

                            if ( dayTime.to > to || dayTime.from > dayTime.to || isFirstWithoutOtherTimeCategories ){
                                dayTime.to = to;
                            }

                            if ( from > dayTime.from || isFirstWithoutOtherTimeCategories ){
                                dayTime.from = from;
                            }

                            if ( product.times[k].opened == false ){
                                dayTime.opened = false;
                            }
                        }
                    }
                }

                return times;
            },
            isPlannedDelivery(){
                return this.isSelectedDelivery(4) || this.isSelectedDelivery(5) || this.ownContractorDelivery;
            },
            hasNoAvailableHours(){
                return this.availableDays.filter(day => this.hasAvailableDays(day)).length == 0;
            },
        },

        methods: {
            itemPrice : Core.methods.itemPrice,
            getItemOpeningHours(item){
                var hours = this.getCategory(item).getOpeningHours,
                    product = item.product,
                    hasCustomDayTimes = Object.keys(product.getOpeningHours||{}).length > 0;

                if ( hasCustomDayTimes ) {
                    hours = product.getOpeningHours;
                }

                else if ( product && product.available_from_time && product.available_to_time ) {
                    hours = {
                        'PO' : [[
                            product.available_from_time.split(' ')[1].substr(0, 5),
                            product.available_to_time.split(' ')[1].substr(0, 5),
                        ], 'NE']
                    }
                }

                return hours;
            },
            /*
             * Check if selected delivery is opened for received time plus delivery delay
             */
            hasUnopenedProducts(delivery, time){
                var delivery = delivery||this.getSelectedDelivery,
                    delay = delivery ? (delivery.delay_before + this.getRegionAttribute(delivery, 'delay')) : 0,
                    endTime = new Date((time === true ? new Date() : time)||this.delivery.time),
                    date = moment(endTime).add(delay, 'minutes'),
                    dateWithoutDelay = moment(endTime);

                for ( var key in this.basket )
                {
                    if (
                        ! this.isOpened(this.basket[key], null, date)
                        || ! this.isOpened(this.basket[key], null, dateWithoutDelay)
                    ) {
                        return true;
                    }
                }

                return false;
            },
            getDayName(day){
                if ( day == 1 )
                    return 'dnes';

                if ( day == 2 )
                    return 'zajtra';

                return moment().add(day - 1, 'day').format('dddd');
            },
            getDate(day){
                return moment().add(day - 1, 'day').format('DD.MM.Y');
            },
            setDeliveryTime(day, week_day, time){
                if ( this.isInPast(day, week_day, time) )
                    return;

                var time = moment(moment().add(day - 1, 'day').format('Y-MM-DD') + ' ' + time + ':00');

                this.delivery.time = time.toString();
            },
            isSelectedTime(day, time){
                var day = moment().add(day - 1, 'day'),
                    selected = moment(new Date(this.delivery.time));

                return selected.format('Y-MM-DD') == day.format('Y-MM-DD') && selected.format('HH:mm') == time;
            },
            isInPast(day, orig_week_day, time){
                var selected_date_format = moment().add(day - 1, 'day').format('Y-MM-DD') + ' ' + time,
                    selected_date = moment(selected_date_format),
                    selected_day = moment(selected_date);

                //If is night hour from previous day
                if ( parseInt(orig_week_day) != selected_day.get('day') )
                    selected_day.add(-1, 'day');

                var now = moment().add(this.isContractor ? 2 : 1, 'hour'),
                    week_day = orig_week_day + '',
                    times = _.find(this.getClientOpeningHours.times, { day : week_day });

                //Check if date is smaller than now, and if is opened in actual time
                return selected_date < now
                       || this.delivery.deadlines.indexOf(selected_date_format) > -1
                       || times && times.opened == false
                       || !this.isContractor && this.$root.isClosedDate(selected_date.format('Y-MM-DD'), this.getClientOpeningHours);
            },
            getScheduleHour(day){
                var opening_hours = this.getClientOpeningHours,
                    d = new Date(),
                    week_date = new Date(d.setDate(d.getDate() + day - 1)),
                    week_day = week_date.getDay(),
                    week_day = this.$root.getWeekDay(week_day) + '',
                    prev_week_day = this.$root.getWeekDay(parseInt(week_day) - 1) + '',
                    actual_day = _.find(opening_hours.times, { day : week_day }),
                    arr = {};

                arr[week_day] = [];
                arr[prev_week_day] = [];

                if ( ! actual_day ) {
                    return [];
                }

                var from = actual_day.from.split(':').map(item => parseInt(item)),
                    to = actual_day.to.split(':').map(item => parseInt(item)),
                    end_today = moment(week_date).add(to[0] < from[0] ? 1 : 0, 'day')
                                                 .set('hour', to[0] < from[0] ? 0 : to[0])
                                                 .set('minute', to[0] < from[0] ? 0 : to[1])
                                                 .set('second', 0)
                                                 .millisecond(0);

                //If end date is lower than start, then get night hours from previous day
                var prev_actual_day = _.find(opening_hours.times, { day : prev_week_day }),
                    prev_day_from = prev_actual_day.from.split(':').map(item => parseInt(item)),
                    prev_day_to = prev_actual_day.to.split(':').map(item => parseInt(item)),
                    prev_day_overnight = prev_day_to[0] > 0 && prev_day_to[0] < prev_day_from[0] && prev_day_to[0] < from[0];

                //If prev day is greater than night...
                if ( prev_day_overnight ){
                    to = prev_day_to;
                }

                var start = moment(week_date).set('hour', from[0]).set('minute', from[1]).set('second', 0).millisecond(0),
                    end = moment(week_date).add(1, 'day')
                                           .set('hour', to[0] < from[0] && prev_day_overnight ? to[0] : 0)
                                           .set('minute', to[0] < from[0] && prev_day_overnight ? to[1] : 0)
                                           .set('second', 0)
                                           .millisecond(0);

                var basket = _.cloneDeep(this.basket);
                while (start < end)
                {
                    var date_day_orig = this.$root.getWeekDay(start.get('day'))+'',
                        date_day = date_day_orig;

                    if ( date_day == week_day && start < end_today || date_day_orig != week_day ){
                        if ( date_day != week_day ) {
                            date_day = prev_week_day;
                        }

                        var opened = true;

                        if ( this.isContractor == false ) {
                            for ( var key in basket ){
                                var item = basket[key],
                                    startDate = moment(new Date(start.toDate()));

                                if ( this.isOpened(item, null, startDate) == false ) {
                                    opened = false;
                                    break;
                                }
                            }
                        }

                        if ( opened == true ) {
                            arr[date_day].push(start.format('HH:mm'));
                        }
                    }

                    start.add(parseInt(opening_hours.step), 'minute');
                }

                return arr;
            },
            getTimeInterval(time){
                var opening_hours = this.getClientOpeningHours;

                return time + ' - ' + moment(moment().format('YYYY-MM-DD') + ' ' + time).add(parseInt(opening_hours.step), 'minute').format('HH:mm');
            },
            getDeliveryName(delivery){
                return delivery.name.replace('{min}', delivery.delay + this.getRegionAttribute(delivery, 'delay'));
            },
            pad(number){
                number = ''+number;

                return number.length == 1 ? '0'+number : number;
            },
            asset(value){
                return this.$root.basepath + value;
            },
            toPrice : Core.methods.toPrice,
            checkCode : Core.methods.checkCode,
            getVariants : Core.methods.getVariants,
            removeItem : Core.methods.removeItem,
            hasProductNotEnoughtQty(product){
                var qty = 0;

                for ( var key in this.basket )
                {
                    if ( this.basket[key].product.id == product.id )
                    {
                        qty += this.basket[key].quantity;
                    }
                }

                return product.quantity < qty;
            },
            isSelectedDelivery(id){
                return this.delivery.selected == id;
            },
            checkForUnCorrectUserDelivery(){
                //Reset contractor delivery
                if ( this.isContractor ){
                    if ( this.isSelectedDelivery(1) || this.isSelectedDelivery(4) )
                        this.resetSelectedDelivery();
                }

                //Auto select planned delivery
                else if ( !this.isSelectedDelivery(4) && this.hasUnopenedProducts() ){
                    this.setDelivery(4);
                }

                //If is selected contractor delivery but client is not contractor
                else if ( this.isSelectedDelivery(5) ) {
                    this.resetSelectedDelivery();
                }
            },
            resetSelectedDelivery(){
                this.delivery.selected = null;
                this.delivery.time = null;
            },
            /*
             * Returns default delivery settings
             */
            getDefaultDeliveryTime(delivery_items, can_default){
                var time = null,
                    selected = null,
                    default_delivery = window.Laravel.data.selected_delivery,
                    deliveries = delivery_items ? delivery_items : this.delivery.items;

                //Return default delivery timestamp received from server
                if ( default_delivery && can_default )
                {
                    selected = default_delivery.id;

                    if ( default_delivery.timestamp )
                        time = new Date( parseInt(default_delivery.timestamp) * 1000 );
                }

                if ( ! time )
                    time = new Date();

                return {
                    selected : selected,
                    time : time,
                };
            },
            getDelivery(id){
                return _.find(this.delivery.items, { id : parseInt(id) });
            },
            setDelivery(id, just_opened){
                var delivery = this.getDelivery(id);

                //If basket has products with non express delivery
                if ( id == 2 && this.hasNonExpressProducts){
                    return this.$root.setMessage(this._('Ľutujeme no expresná doprava vo Vašom prípade nie je možná, kedže v košíku sa nachádzajú potravinové produkty.'));
                }

                if ( id == 3 && this.hasNonStoreDeliveryProducts){
                    return this.$root.setMessage(this._('Ľutujeme, no osobný odber pre vybrané produkty nie je možný.'));
                }

                //If is not planned delivery into the future, then reset time
                if ( [4, 5].indexOf(id) == -1 ){
                    var time = new Date().toString();

                    if ( just_opened === true && this.hasUnopenedProducts(delivery, true) ) {
                        return this.$root.setMessage(this._('Lutujeme, no pre vybrané produkty nie je doručenie tohto typu dostupné. Zvoľte prosím naplánované doručenie.'));
                    }

                    this.delivery.time = time;
                }

                this.delivery.selected = id;
            },
            getRegionAttribute(delivery, attribute){
                if ( this.delivery.region )
                {
                    var region_rule = delivery ? _.find(this.delivery.region.rules, { delivery_id : delivery.id }) : null;

                    if ( region_rule )
                        return parseFloat(region_rule[attribute]||0);
                }

                return parseFloat(this.delivery.region ? (this.delivery.region[attribute]||0) : 0);
            },
            getDeliveryPrice(delivery){
                var region_price = this.getRegionAttribute(delivery, 'price'),
                    region_min_price = parseFloat(this.delivery.region ? this.delivery.region.minimum_price : 0),
                    delivery_price = parseFloat(delivery.price);

                if ( delivery.id == 3 )
                    return this.toPrice(0);

                //If is free price over limit order
                if ( delivery.price_free && (this.totalPriceProfitable >= delivery.price_free && this.delivery.region.delay == 0) || (this.cupoun && this.cupoun.free_delivery == true) )
                    return this.toPrice(0 + region_price);

                //Checks if basket has product with free delivery
                for ( var key in this.basket )
                {
                    for ( var d in this.basket[key].product.free_delivery )
                    {
                        if ( this.basket[key].product.free_delivery[d].id == delivery.id )
                            return this.toPrice(0 + region_price);
                    }
                }

                //If order is under limit, then add extra delivery price
                if (
                    (!region_min_price || this.totalPriceProfitable > region_min_price)
                    && this.totalPriceProfitable < parseFloat(this.limit.under)
                ){
                    return this.toPrice(delivery_price + parseFloat(this.limit.extra) + region_price);
                }

                return this.toPrice(delivery.price + region_price);
            },
            getCategory(item){
                if ( item.product.subcategories.length == 0 )
                    return {};

                return _.find(this.$root.categories, {
                    id : parseInt(item.product.subcategories[0].category_id)
                }) || {};
            },
            getOpeningHourById(id){
                for ( var key in this.opening_hours )
                    if ( this.opening_hours[key].id == id )
                        return this.opening_hours[key];
            },
            /*
             * Returns times for actual day from selected delivery time for inserted opening hours
             */
            getTodayTimes(opening_hours, week_day, now_orig){
                if ( !week_day ) {
                    week_day = new Date(now_orig||this.delivery.time).getDay();
                }

                if ( week_day == 0 ) {
                    week_day = 7;
                }

                for ( var key in opening_hours.times ) {
                    if ( parseInt(opening_hours.times[key].day) == week_day ) {
                        return opening_hours.times[key];
                    }
                }
            },
            isProductTimesOpened(item, now_orig){
                let opened = true,
                    product = item.product,
                    now = new Date(now_orig||this.delivery.time),
                    todayTimes;

                now.setSeconds(0);
                now = moment(new Date(now_orig||this.delivery.time).setSeconds(0));

                if ( product.times && product.times.length && opened == true ){
                    todayTimes = this.getTodayTimes(product, null, now_orig);

                    if ( todayTimes ){
                        let from = moment(now.format('Y-MM-DD')+' '+todayTimes.from),
                            to = moment(now.format('Y-MM-DD')+' '+todayTimes.to);

                        opened = now >= from && now <= to && todayTimes.opened;
                    }
                }

                //If timetable for actual day is not present
                if ( !todayTimes && product.available_from_time && product.available_to_time && opened == true ){
                    let from = moment(now.format('Y-MM-DD')+' '+product.available_from_time.split(' ')[1]),
                        to = moment(now.format('Y-MM-DD')+' '+product.available_to_time.split(' ')[1]);

                    opened = now >= from && now <= to;
                }

                return opened;
            },
            /*
             * Checks if has items which belongs to category opened delivery
             */
            isOpened(item, week_day, now_orig){
                //Contractor client has opened all time
                if ( this.isContractor )
                    return true;

                var category = this.getCategory(item),
                    opened = true;

                opened = this.isProductTimesOpened(item, now_orig);

                if ( (opened == true) && (category.opening_hours_id) ) {
                    var opening_hours = this.getOpeningHourById(category.opening_hours_id);

                    if ( ! opening_hours )
                        return true;

                    var times = this.getTodayTimes(opening_hours, week_day, now_orig),
                        now = new Date(now_orig||this.delivery.time);
                        now.setSeconds(0);

                    if ( ! times ){
                        return true;
                    }

                    var from = times.from.split(':'),
                        to = times.to.split(':');

                    var from_date = new Date(now);
                        from_date.setHours(from[0]);
                        from_date.setMinutes(from[1]);
                        from_date.setSeconds(0);

                    var to_date = new Date(now);
                        to_date.setHours(to[0]);
                        to_date.setMinutes(to[1]);
                        to_date.setSeconds(0);

                    if ( now < from_date && week_day == null )
                    {
                        week_day = new Date(now_orig||this.delivery.time).getDay() - 1;

                        //If is today sunday, we turn it to saturday
                        if ( week_day == -1 )
                            week_day = 6;

                        week_day = this.$root.getWeekDay(week_day);

                        return this.isOpened(item, week_day, now_orig);
                    }

                    //If closing time is lower then opening, set closing to next day
                    if ( to_date <= from_date )
                        to_date.setDate( to_date.getDate() + 1 );

                    if ( week_day != null )
                    {
                        from_date.setDate( from_date.getDate() - 1 );
                        to_date.setDate( to_date.getDate() - 1 );
                    }

                    opened = now >= from_date && now < to_date && ! this.$root.isClosedToday(times, opening_hours);
                }

                //If is not opened some product, then auto set delivery to time
                if ( !opened && this.delivery.selected === null ) {
                    this.setDelivery(4);
                }

                return opened;
            },
            autoSelectDay(time){
                this.selected_day = parseInt(moment(moment(new Date(time||this.delivery.time)).format('Y-MM-DD')).diff(moment(moment().format('Y-MM-DD')), 'days')) + 1;
            },
            selectDay(day){
                if ( this.selected_day == day )
                    this.selected_day = null;
                else
                    this.selected_day = day;
            },
            /*
             * Returns product path
             */
            getProductAction : Core.methods.getProductAction,
            /*
             * Nech step
             */
            submitOrder(){
                //Check error messages
                if ( this.checkErrors() !== true )
                    return;

                this.loading = true;

                //Save product into basket in session
                $.ajax({
                    url : window.Laravel.requests.basket.send,
                    method : 'post',
                    success : function(response){
                        window.ajaxResponse(response);

                        this.loading = false;
                    }.bind(this),
                    error : function(){
                        window.errorResponse();

                        this.loading = false;
                    }.bind(this),

                });
            },
            checkErrors(){
                //Reset checkbox errors
                $('.cart-checkboxes .error').removeClass('error');

                //Checks for product quantity
                for ( var key in this.basket )
                    if ( this.hasProductNotEnoughtQty(this.basket[key].product) )
                        return this.$root.setMessage(this._('Ľutujeme. No produkt :product s požadovaným množstvom momentálne nemáme na sklade. Skúste neskôr prosím, alebo nás skuste kontaktovať.').replace(':product', this.basket[key].product.name), 'error');

                //If delivery on time is in past date
                if ( this.isPlannedDelivery )
                {
                    var time = new Date(this.delivery.time),
                        now = new Date();

                    now.setHours( now.getHours() + 1 );

                    if ( time <= now )
                    {
                        return this.$root.setMessage(
                            this.isContractor ? this._('Pri plánovaní doručenia na určitý čas pre veľkoobchod musíte zadať termín minimálne dve hodiny od aktuálneho času.')
                            : this._('Pri plánovaní doručenia na určitý čas musíte zadať termín minimálne jednú hodinu od aktuálneho času.')
                        , 'error');
                    }
                }

                //Checks if is some product in error state with delivery
                if ( this.isSelectedDeliveryOverTime )
                    return this.$root.setMessage(this._('Prve musíte vyriešit konflitky s doručením pri daných produktoch.'), 'error');

                //Checks if is some product in error state with delivery
                if ( ! this.delivery.selected )
                    return this.$root.setMessage(this._('Vyberte prosím spôsob doručenia.'), 'error');

                //If is not delivery on place, then disallow delivery under region prices
                if ( this.delivery.selected != 3 && parseFloat(this.totalPriceProfitableWithDiscount) < this.delivery.region.minimum_price )
                {
                    return this.$root.setMessage(this._('Ľutujeme, no minimálna cena objednávky pre región {region} je {price} €. Vaša aktuálna výška objednávky bez dopravy a ceny cigariet je {totalprice}€.')
                                     .replace('{price}', this.toPrice(this.delivery.region.minimum_price))
                                     .replace('{region}', this.delivery.region.name)
                                     .replace('{totalprice}', this.totalPriceProfitableWithDiscount)
                    , 'error');
                }

                if ( ! this.has18 )
                    $('#has18').parent().addClass('error');

                if ( ! this.vop )
                    $('#accept').parent().addClass('error');

                //If has form vop
                if ( ! this.vop )
                    return this.$root.setMessage(this._('Pre vytvorenie objednávky, prosím zaškrtnite, že súhlasíte s obchodnými podmienkami.'), 'error');

                if ( ! this.has18 )
                    return this.$root.setMessage(this._('Ľutujeme, no pri osobach mladších ako 18 rokov nie je možné vytvoriť objednávku.'), 'error');

                //If is no express in basket
                if ( this.hasNonExpressProducts && this.delivery.selected == 2 )
                    return this.$root.setMessage(this._('Ľutujeme no expresná doprava vo Vašom prípade nie je možná, kedže v košíku sa nachádzajú potravinové produkty.'));

                return true;
            },
            hasAvailableDays(i){
                var hours = this.getScheduleHour(i);

                for ( var week_day in hours )
                {
                    for ( var time in hours[week_day] )
                    {
                        if ( ! this.isInPast(i, week_day, hours[week_day][time]) ){
                            return true;
                        }
                    }
                }

                //We can display max 14 days into future
                if ( this.availableDays.indexOf(i) > -1 && i <= 14 ) {
                    this.availableDays.push(this.availableDays[this.availableDays.length - 1] + 1);
                    this.availableDays.splice(this.availableDays.indexOf(i), 1);
                }

                return false;
            },
            hasOneTime(days, i, week_day){
                for ( var t in days )
                {
                    var time = days[t];

                    if ( ! this.isInPast(i, week_day, time) )
                        return true;
                }

                return false;
            },
        }
    }
</script>